import React from 'react';
import { PageProps } from '../../types/page';
import AppPage from './AppPage';
import Scripts from './scripts/Scripts';
import Footer from '../../components/landing/Footer';
import FooterColumns from '../../components/landing/FooterColumns';

type Props = PageProps;

/**
 * Wrap app page with server side rendered blocks.
 */
const AppPageWrapper = (props: Props) => {
  const { showFooter = true, renderOnClient } = props;

  return (
    <>
      <Scripts
        asPath={props.asPath}
        pathname={props.pathname}
        user={props.user}
      />
      <AppPage isLoggedIn={Boolean(props.user?.userID)} {...props} />
      {showFooter && (
        <Footer isPagesRouter={renderOnClient}>
          <FooterColumns isPagesRouter={renderOnClient} />
        </Footer>
      )}
    </>
  );
};

export default AppPageWrapper;
